export const mapResponseToAssets = (assetConnectionDetails = []) =>
    assetConnectionDetails.map(({ assetId, assetName, connectionHistory = [] }) => ({
        assetId,
        assetName,
        segments: connectionHistory.map(({ status, startTime, endTime }) => ({
            status,
            start: startTime,
            end: endTime,
        })),
    }));
